<template>
  <v-container fluid fill-height>
    <LoginForm
      @openPasswordAssistanceDialog="handleOpenPasswordAssistanceDialog"
    ></LoginForm>
    <template>
      <v-dialog v-model="passwordAssistanceDialog" max-width="500px">
        <v-card class="px-5">
          <v-card-title class="font-weight-light text-h5">
            Password assistance
          </v-card-title>
          <v-card-text>
            To recieve password reset token, please enter the email address
            associated with your account. If you already recieved a token, click
            on "I HAVE A TOKEN" button.
            <PasswordAssistance
              class="mt-5"
              @success="showSuccess"
              @error="showError"
            />
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn @click="passwordResetDialog = true">I have a token</v-btn>
            <v-btn color="primary" @click="passwordAssistanceDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
    <template>
      <v-row justify="center">
        <v-dialog v-model="passwordResetDialog" persistent max-width="500">
          <v-card>
            <v-card-title class="font-weight-light text-h5">
              Reset password
            </v-card-title>
            <v-card-text
              >Please enter the password reset token you received in your email
              and write the new password.

              <PasswordResetForm
            /></v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>

              <v-btn
                color="green darken-1"
                text
                @click="passwordResetDialog = false"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
  </v-container>
</template>
<script>
import LoginForm from "../components/LoginForm.vue";
import PasswordAssistance from "../components/PasswordAssistance.vue";
import PasswordResetForm from "../components/PasswordResetForm.vue";

export default {
  name: "Login",
  components: {
    LoginForm,
    PasswordAssistance,
    PasswordResetForm,
  },
  data: function () {
    return {
      passwordAssistanceDialog: false,
      passwordResetDialog: false,
      password: "",
      showPassword: false,
    };
  },
  methods: {
    handleOpenPasswordAssistanceDialog: function () {
      this.passwordAssistanceDialog = true;
    },
    showError: function () {},
    showSuccess: function () {},
  },
};
</script>
